<template>
  <div class="filter-wrapper">
    <a-form :model="filterData">
      <div class="df">
        <a-form-item label="任务ID" style="margin-right: 20px;">
          <a-input
            v-model:value="filterData.taskId"
            style="width: 180px"
            @change="initList"
            placeholder="请输入任务ID"
          />
        </a-form-item>
        <!-- <a-form-item label="直播间" name="liveId">
          <a-select
            v-model:value="filterData.liveId"
            placeholder="请选择直播间"
            allow-clear
            style="width: 150px"
            @change="selectLiveRoom"
          >
            <a-select-option
              v-for="(item, index) in liveRoomSelect"
              :key="index"
              :value="item['id']"
              :label="item['chatGroupName']"
            >
              {{ item['chatGroupName'] }}
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="目标类型" style="margin-right: 20px;">
          <a-select
            ref="select"
            v-model:value="filterData.targetType"
            style="width: 180px"
            placeholder="请选择"
            allow-clear
            @change="initList"
          >
            <a-select-option :value="'1'" key="签到">
              签到
            </a-select-option>
            <a-select-option :value="'2'" key="浏览">
              浏览
            </a-select-option>
            <a-select-option :value="'3'" key="分享">
              分享
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="任务状态" style="margin-right: 20px;">
          <a-select
            ref="select"
            v-model:value="filterData.status"
            style="width: 180px"
            placeholder="请选择"
            allow-clear
            @change="initList"
          >
            <a-select-option :value="0" key="未激活">未激活</a-select-option>
            <a-select-option :value="1" key="激活">激活</a-select-option>
          </a-select>
        </a-form-item>
        <div class="btn-wrapper">
          <a-button class="mr10" type="primary" @click="initList"
            >查询</a-button
          >
          <a-button @click="resetFilter">重置</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  margin-bottom: 10px;
}
.btn-wrapper {
  margin-left: auto;
}
</style>
